import * as Sentry from "@sentry/react";

const isLocalhost = (url) => url.includes("localhost");
const isQa = (url) => url.includes("qa.everest");

Sentry.init({
    dsn: "https://28aa579d0782d3247900c9f7eca12cd9@o416535.ingest.us.sentry.io/4508364476252160",
    enabled: !isLocalhost(window.location.href),
    sendDefaultPii: true,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],
    enableLogs: true,
    tracesSampleRate: 1.0,
    tracePropagationTargets: [],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
        if (isLocalhost(event.request.url)) {
            return null;
        }
        else if (isQa(event.request.url)) {
            return null;
        }

        // Exclude zod validation errors (especially required field errors)
        const error = event.exception?.values?.[0];
        if (error) {
            const errorMessage = error.value || "";
            const errorType = error.type || "";

            // Check if it's a zod validation error
            const isZodError =
                errorType === "ZodError" ||
                errorMessage.includes("ZodError") ||
                errorMessage.includes("This field is required") ||
                errorMessage.includes("field is required") ||
                errorMessage.includes("Required") ||
                (errorMessage.includes("required") && errorMessage.toLowerCase().includes("field")) ||
                errorMessage.includes("You can’t log hours because no billable is available for this date");
            if (isZodError) {
                return null; // Don't send zod validation errors to Sentry
            }
        }

        return event;
    },
});